import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { B100, N20, N200, N30 } from '@atlaskit/theme/colors';
import { fontSize as fontSizeFn, gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { headingSizes } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';
var gridSize = gridSizeFn();
var fontSize = fontSizeFn();
var itemTopBottomPadding = gridSize;
var itemSidePadding = gridSize * 2.5;
var itemElemSpacing = gridSize * 1.5;
var itemDescriptionSpacing = gridSize * 0.375;
var itemMinHeight = gridSize * 5;
var itemContentMinHeight = itemMinHeight - itemTopBottomPadding * 2;
var disabledStyles = {
  cursor: 'not-allowed',
  '&, &:hover, &:focus, &:active': {
    backgroundColor: 'transparent',
    color: token('color.text.disabled', N200)
  },
  '&:focus': {
    boxShadow: 'none'
  }
};
var selectedStyles = {
  backgroundColor: token('color.background.selected.resting', N20),
  // Suppress the need for a fallback as selected color isn't used in the non-tokens world.
  // When removing fallbacks make sure to remove this supression.
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  color: token('color.text.selected'),
  ':hover': {
    backgroundColor: token('color.background.selected.hover', N20),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    color: token('color.text.selected')
  },
  ':active': {
    backgroundColor: token('color.background.selected.pressed', N30),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    color: token('color.text.selected')
  },
  ':visited': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    color: token('color.text.selected')
  }
};
export var baseItemCSS = function baseItemCSS(isDisabled, isSelected) {
  return _objectSpread(_objectSpread({
    padding: "".concat(itemTopBottomPadding, "px ").concat(itemSidePadding, "px"),
    cursor: 'pointer',
    fontSize: fontSize,
    // IE11 fix - wrapping container needs to be flex as well for vertical centering to work.
    display: 'flex',
    boxSizing: 'border-box',
    color: 'currentColor',
    userSelect: 'none',
    '&:visited': {
      color: 'currentColor'
    },
    '&:hover': {
      color: 'currentColor',
      backgroundColor: token('color.background.transparentNeutral.hover', N20),
      textDecoration: 'none'
    },
    '&:focus': {
      outline: 'none',
      boxShadow: "".concat(token('color.border.focus', B100), " 0 0 0 2px inset")
    },
    '&:active': {
      boxShadow: 'none',
      color: 'currentColor',
      backgroundColor: token('color.background.transparentNeutral.pressed', N30)
    },
    '::-moz-focus-inner': {
      border: 0
    }
  }, isSelected && selectedStyles), isDisabled && disabledStyles);
};
export var contentCSS = {
  flexGrow: 1,
  textAlign: 'left',
  overflow: 'hidden',
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
  // Fix - avoid clipped text descenders when using standard 16px line-height
  lineHeight: 1.22
};
export var truncateCSS = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};
export var wrapTextCSS = {
  wordBreak: 'break-word'
};
export var elemBeforeCSS = {
  display: 'flex',
  flexShrink: 0,
  marginRight: itemElemSpacing
};
export var elemAfterCSS = {
  display: 'flex',
  flexShrink: 0,
  marginLeft: itemElemSpacing
};
var descriptionBaseCSS = {
  color: token('color.text.lowEmphasis', N200),
  marginTop: itemDescriptionSpacing,
  fontSize: headingSizes.h200.size
};
export var wrapDescriptionCSS = _objectSpread(_objectSpread({}, wrapTextCSS), descriptionBaseCSS);
export var descriptionCSS = _objectSpread(_objectSpread({}, truncateCSS), descriptionBaseCSS);
export var contentCSSWrapper = {
  display: 'flex',
  minHeight: itemContentMinHeight,
  alignItems: 'center',
  // IE11 fix - used with flex above to fix vertical centering.
  width: '100%'
};